module.exports = __webpack_public_path__ + "img/gas.df55678.jpg";